<template>
    <div class="login">
        <!-- Logo -->
        <div class="logo-container">
            <img src="@/assets/img/全称logo横版-02.png" alt="Logo" class="logo" />
        </div>
        
        <!-- 登录表单 -->
        <div class="from">
            <!-- 系统标题 -->
            <div class="system-title">
                <img src="@/assets/img/logo2.png" alt="智检云枢" class="system-logo" />
                <div class="system-brand">智检云枢</div>
                <div class="brand-line"></div>
                <h1>建研国检智能检测系统</h1>
                <div class="title-subtitle">CABR TESTING CENTER Intelligent Detection System</div>
            </div>
            
            <form @submit.prevent="login" autocomplete="on">
                <el-input 
                    v-model="input" 
                    size="large" 
                    placeholder="请输入您的账号" 
                    :prefix-icon="User"
                    name="username"
                    autocomplete="username"
                />
                <div class="password">
                    <el-input 
                        v-model="password" 
                        @keyup.enter="login" 
                        size="large" 
                        type="password" 
                        placeholder="请输入您的密码" 
                        show-password 
                        :prefix-icon="Lock"
                        name="password"
                        autocomplete="current-password"
                    />
                </div>
                <div class="login-btn" @click="login" :class="{ loading: loginLoading }">
                    <span v-if="!loginLoading">登录</span>
                    <span v-else>登录中...</span>
                </div>
                <div class="change-password-link" @click="showChangePasswordDialog = true">
                    修改密码
                </div>
            </form>
        </div>

        <!-- 修改密码对话框 -->
        <el-dialog
            v-model="showChangePasswordDialog"
            title="修改密码"
            width="400px"
            :close-on-click-modal="false"
        >
            <el-form :model="changePasswordForm" label-width="80px">
                <el-form-item label="用户名">
                    <el-input v-model="changePasswordForm.name" placeholder="请输入用户名" />
                </el-form-item>
                <el-form-item label="旧密码">
                    <el-input 
                        v-model="changePasswordForm.oldpass" 
                        type="password" 
                        placeholder="请输入旧密码"
                        show-password
                    />
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input 
                        v-model="changePasswordForm.pass" 
                        type="password" 
                        placeholder="请输入新密码"
                        show-password
                    />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="showChangePasswordDialog = false">取消</el-button>
                <el-button type="primary" @click="handleChangePassword" :loading="changePasswordLoading">
                    确定
                </el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { home } from "@/network/index";
import { ElMessage } from 'element-plus'
import { User, Lock } from '@element-plus/icons-vue';
import addDynamicRoutes from '@/utils/addRoutes';
import { useMenuStore } from '@/store/menuStore';
import { clearAuthCache } from '@/utils/authCache';

const extractPermissionMenus = (responseData: any): any[] => {
    if (!responseData) return [];
    if (Array.isArray(responseData)) return responseData;
    if (Array.isArray(responseData.children)) return responseData.children;
    return [];
};

const loginLoading = ref(false); 
const input = ref("");
const password = ref("");
const router = useRouter()

// 修改密码相关
const showChangePasswordDialog = ref(false);
const changePasswordLoading = ref(false);
const changePasswordForm = ref({
    name: '',
    oldpass: '',
    pass: ''
});

// 修改密码处理函数
const handleChangePassword = async () => {
    if (!changePasswordForm.value.name || !changePasswordForm.value.oldpass || !changePasswordForm.value.pass) {
        ElMessage.warning('请填写完整信息');
        return;
    }
    
    changePasswordLoading.value = true;
    try {
        const res = await home.ChangePassword({
            name: changePasswordForm.value.name,
            pass: changePasswordForm.value.pass,
            oldpass: changePasswordForm.value.oldpass
        }) as { status?: number; success?: boolean; msg?: string; data?: { msg?: string } };
        
        const isSuccess = res.success === true || res.status === 200 || res.msg?.includes('成功');
        if (isSuccess) {
            ElMessage.success(res.msg || '密码修改成功');
            showChangePasswordDialog.value = false;
            // 清空表单
            changePasswordForm.value = { name: '', oldpass: '', pass: '' };
        } else {
            ElMessage.error(res.msg || res.data?.msg || '密码修改失败');
        }
    } catch (error) {
        console.error('修改密码失败:', error);
        ElMessage.error('修改密码请求失败');
    } finally {
        changePasswordLoading.value = false;
    }
};
// const data:any = reactive({});


const login = async () => {
 // 如果正在登录中，则不处理重复点击
 if (loginLoading.value) return;
 loginLoading.value = true;
    
    // 设置loading状态
    loginLoading.value = true;
    
try {
    
    //正常登录流程
    const res = await home.PostLogin({
        name: input.value,
        pass: password.value
    }) as { status: number; response: { token: string }; data?: { msg: string } };
    
    // 判断HTTP状态码
    if (res.status !== 200) {
        ElMessage({ message: '网络请求失败，请稍后再试!', type: 'error' })
        return;
    }
    
    // 判断业务逻辑错误（如认证失败）
    if (res.data?.msg && res.data.msg.includes('认证')) {
        ElMessage({ message: '用户名或密码错误!', type: 'error' })
        return;
    }
    
    console.log("登录", JSON.parse(JSON.stringify(res)));
    
    // 登录成功
    const menus = res.response.token;
    const menuStore = useMenuStore();
    clearAuthCache();
    menuStore.clearMenus();
    sessionStorage.setItem('wuyetoken', menus)//浏览器缓存存储
    localStorage.setItem('wuyetoken', menus)//持久化存储，支持新标签页打开
    //存储信息
    const tokenData = await home.GetInfoByToken({ token: menus }) as { response: { uID: string } };
    console.log(tokenData);
    // 获取用户权限菜单
    let menusData: any[] = [];
    try {
        const permissionRes = await home.GetUserPermission(
            { uid: tokenData.response.uID },
            { suppressBusinessErrorMessage: true }
        );
        menusData = extractPermissionMenus(permissionRes.response);
    } catch (permissionError) {
        console.error("获取权限菜单失败", permissionError);
        menusData = [];
    }

    localStorage.setItem('wuyemenusJSON', JSON.stringify(menusData));
    const buttonPermissions: string[] = [];
    
    const extractButtonPermissions = (menus: any[]) => {
        menus.forEach(menu => {
            if (menu.IsButton) {
                const permissionName = menu.Func || menu.name || menu.meta?.title;
                if (permissionName) buttonPermissions.push(permissionName);
            }
            
            if (menu.children && menu.children.length > 0) {
                extractButtonPermissions(menu.children);
            }
        });
    };
    
    extractButtonPermissions(menusData);
    localStorage.setItem('buttonPermissions', JSON.stringify(buttonPermissions));
    localStorage.setItem('menuPermissionSyncedAt', String(Date.now()));
    menuStore.setMenus(menusData);
    addDynamicRoutes(router, menusData);

    if (menusData.length === 0) {
        ElMessage({
            message: '当前人员无菜单权限，为您登录首页',
            type: 'success',
            customClass: 'login-empty-menu-message'
        });
    } else {
        ElMessage({ message: '登录成功!', type: 'success' })
    }

    router.push("/home");
} catch (error: unknown) {
    console.error("登录请求失败:", error);
    // ElMessage({ message: '登录失败，请检查用户名和密码!', type: 'error' });
}finally {
    loginLoading.value = false;
}
};

//添加监听
onBeforeMount(() => {
console.log("组件首次挂载之前");
});

onMounted(() => {
console.log("组件首次挂载完成");
});
</script>
<style lang="less" scoped>
.login {
    // 背景图片设置
    background-image: url('@/assets/img/bgImg.jpg');
    background-size: cover; // 覆盖整个容器，保持宽高比
    background-position: center; // 居中显示
    background-repeat: no-repeat; // 不重复
    background-attachment: fixed; // 固定背景，滚动时不移动
    
    position: fixed; // 使用fixed确保全屏覆盖
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 1;
    
    // 添加毛玻璃遮罩层
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.1); // 半透明白色遮罩
        backdrop-filter: blur(8px); // 毛玻璃模糊效果
        -webkit-backdrop-filter: blur(8px); // Safari兼容
        z-index: 2;
        pointer-events: none; // 不阻止鼠标事件
    }

    // Logo容器
    .logo-container {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 15; // 确保在毛玻璃效果之上
        
        .logo {
            max-width: 200px; // 最大宽度
            max-height: 80px; // 最大高度
            width: auto;
            height: auto;
            object-fit: contain; // 保持宽高比，不拉伸
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3)); // 添加阴影效果
        }
    }

    .from {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(255, 255, 255, 0.95); // 半透明白色背景
        backdrop-filter: blur(10px); // 毛玻璃效果
        border-radius: 15px;
        padding: 2.5rem;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        z-index: 10; // 确保在毛玻璃效果之上
        
        // 响应式宽度
        width: 90%;
        max-width: 450px;
        min-width: 320px;

        // 系统标题样式
        .system-title {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            margin-bottom: 2rem;

            .system-logo {
                width: 128px;
                height: 128px;
                object-fit: contain;
                background: transparent;
                margin-bottom: 12px;
                transition: transform 0.3s ease;

                &:hover {
                    transform: scale(1.05);
                }
            }

            .system-brand {
                font-size: 26px;
                font-weight: 600;
                letter-spacing: 2px;
                background: linear-gradient(135deg, #1677ff 0%, #409eff 50%, #66b3ff 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                margin-bottom: 8px;
                font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
            }

            .brand-line {
                width: 44px;
                height: 3px;
                border-radius: 2px;
                background: linear-gradient(90deg, transparent, #409eff, transparent);
                margin-bottom: 14px;
            }

            h1 {
                color: #2c3e50;
                font-size: 24px;
                font-weight: 600;
                margin: 0 0 8px 0;
                background: linear-gradient(135deg, #409eff, #66b3ff);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }

            .title-subtitle {
                color: #7f8c8d;
                font-size: 10px;
                font-weight: 400;
                letter-spacing: 0.5px;
                text-transform: uppercase;
                opacity: 0.8;
                white-space: nowrap;
            }
        }

        .title {
            color: black;
            font-size: 18px;
            font-weight: bold;
            background-color: transparent;
            text-align: center;
            margin-bottom: 2rem;
        }

        .password {
            margin-top: 1rem;
        }

        .login-btn {
            margin-top: 1.5rem;
            color: white;
            text-align: center;
            padding: 12px 0;
            border-radius: 8px;
            background: linear-gradient(135deg, #409eff, #66b3ff);
            cursor: pointer;
            font-size: 16px;
            font-weight: 500;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(64, 158, 255, 0.3);

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(64, 158, 255, 0.4);
            }

            // 添加loading状态样式 
            &.loading {
                background: linear-gradient(135deg, #a0cfff, #b3d9ff);
                cursor: not-allowed;
                position: relative;
                transform: none;
                
                &::after {
                    content: "";
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    top: 50%;
                    left: 50%;
                    margin-top: -10px;
                    margin-left: -10px;
                    border: 2px solid #ffffff;
                    border-radius: 50%;
                    border-top-color: transparent;
                    animation: rotate 1s linear infinite;
                }
                
                span {
                    visibility: hidden;
                }
            }
        }

        // 修改密码链接样式
        .change-password-link {
            margin-top: 1rem;
            text-align: center;
            color: #409eff;
            font-size: 14px;
            cursor: pointer;
            transition: color 0.3s ease;
            
            &:hover {
                color: #66b3ff;
                text-decoration: underline;
            }
        }
    }
}

// 旋转动画
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

// 响应式设计
@media (max-width: 768px) {
    .login {
        .logo-container {
            top: 15px;
            left: 15px;
            
            .logo {
                max-width: 150px;
                max-height: 60px;
            }
        }
        
        .from {
            padding: 2rem;
            width: 95%;
            max-width: 400px;
            
            // 移动端系统标题调整
            .system-title {
                margin-bottom: 1.5rem;

                .system-logo {
                    width: 112px;
                    height: 112px;
                }

                .system-brand {
                    font-size: 22px;
                }

                .brand-line {
                    width: 36px;
                }

                h1 {
                    font-size: 20px;
                }

                .title-subtitle {
                    font-size: 9px;
                }
            }
            
            // 移动端输入框宽度调整
            :deep(.el-input) {
                width: 100% !important;
            }
        }
    }
}

@media (max-width: 480px) {
    .login {
        .logo-container {
            top: 10px;
            left: 10px;
            
            .logo {
                max-width: 120px;
                max-height: 50px;
            }
        }
        
        .from {
            padding: 1.5rem;
            width: 98%;
            max-width: 350px;
            
            // 小屏幕系统标题调整
            .system-title {
                margin-bottom: 1.2rem;

                .system-logo {
                    width: 100px;
                    height: 100px;
                }

                .system-brand {
                    font-size: 20px;
                }

                .brand-line {
                    width: 32px;
                }

                h1 {
                    font-size: 18px;
                }

                .title-subtitle {
                    font-size: 8px;
                }
            }
        }
    }
}

// 超小屏幕适配
@media (max-width: 320px) {
    .login {
        .from {
            padding: 1rem;
            width: 100%;
            max-width: 300px;
            
            // 超小屏幕系统标题调整
            .system-title {
                margin-bottom: 1rem;

                .system-logo {
                    width: 88px;
                    height: 88px;
                }

                .system-brand {
                    font-size: 18px;
                }

                .brand-line {
                    width: 28px;
                }

                h1 {
                    font-size: 16px;
                }

                .title-subtitle {
                    font-size: 9px;
                }
            }
        }
    }
}

// 大屏幕优化
@media (min-width: 1920px) {
    .login {
        .logo-container {
            top: 30px;
            left: 30px;
            
            .logo {
                max-width: 250px;
                max-height: 100px;
            }
        }
        
        .from {
            padding: 3rem;
            max-width: 500px;
            
            // 大屏幕系统标题调整
            .system-title {
                margin-bottom: 2.5rem;

                .system-logo {
                    width: 150px;
                    height: 150px;
                }

                .system-brand {
                    font-size: 32px;
                }

                .brand-line {
                    width: 52px;
                }

                h1 {
                    font-size: 28px;
                }

                .title-subtitle {
                    font-size: 11px;
                }
            }
        }
    }
}
</style>
